<div class="modal-header">
    <h3 class="modal-title" id="staticBackdropLabel">Aprobar Solicitud</h3>
    <!--<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>-->
    <fa-icon [icon]="['fas', 'times']" (click)="onCloseModalA()" [size]="'lg'"></fa-icon>
</div>

<div class="modal-body">
    <form class="row g-3" (ngSubmit)="onSubmit()">
        <span>Para confirmar la aprobación click en "Aprobar".</span>
        <button type="submit" class="btn btn-primary" style="background-color: #198754;">Aprobar</button>
    </form>
</div>